import React from "react";
import { AppRoute } from "./routes/AppRoute";
import { useAuth, useUser } from "../../hooks";
import { DropdownLenguaje } from "../../components/templateComponents/DropdownLenguaje";
import { LuLogOut } from "react-icons/lu";
import { useTranslation } from "react-i18next";

export const AppApplicationSelector = () => {
  const { user, status, startLogout } = useAuth();
  const [t] = useTranslation("global");
  const usr = useUser();

  return (
    <div className="h-[100vh]">
      <header className="w-full h-[4vh]  md:h-[6vh] flex gap-x-4 items-center justify-end px-8 bg-skin-primary text-white border-r shadow-sm sticky top-0 z-10 ">
        <div className="grid grid-flow-row py-2 text-xl">
          <span className="text-xxs">
            {`${usr.User.name} ${usr.User.lastName}`}
          </span>
        </div>
        <DropdownLenguaje></DropdownLenguaje>
        <div
          className="btn  text-white"
          title={t("LogOut")}
          onClick={startLogout}
        >
          <LuLogOut />
        </div>
      </header>
      <AppRoute />
    </div>
  );
};
